module.exports = __webpack_public_path__ + "img/microplastics-process-6.fdbead60.png";